import React, { useContext, useMemo } from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Thumbnail from '@amzn/meridian/thumbnail';
import { ShiftAllocationContext } from '../context/ShiftAllocationContext';
import { AssignDestinationPicker } from './AssignDestinationPicker';
import { getBadgePhotoUrl } from './utils';
import { PROCESS_PATHS } from '../data';

// Reusable "associate card" assign panel. Mirrors the click-to-assign flow in EmployeeIcon so a
// scan-driven assignment produces the exact same MOVE_ASSOCIATE dispatch (including aisle spans).
// Deriving the associate's current board entry here lets it work whether they are on the bench or
// already placed on a process card.
const ProcessPathListView = ({ processPathList, title }) => (
  <Row spacing="100">
    <Text type="h100">{title}:</Text>
    <Text type="b300" color="secondary">
      {(processPathList || []).join(', ') || '—'}
    </Text>
  </Row>
);

export const AssignAssociatePanel = ({ associate, onAssigned }) => {
  const { shiftAllocationModel } = useContext(ShiftAllocationContext);

  // The associate's current board entry, used as the MOVE_ASSOCIATE `from`. Defaults to bench when
  // they are not currently placed on any process card.
  const currentBoardEntryId = useMemo(() => {
    const processInfo = (shiftAllocationModel && shiftAllocationModel.processInfo) || [];
    const entry = processInfo.find((e) => (e.assignments || []).some((a) => a.resourceId === associate.alias));
    return entry ? entry.id : PROCESS_PATHS.BENCH;
  }, [shiftAllocationModel, associate]);

  return (
    <Column spacing="300">
      <Row spacing="300" alignmentVertical="center">
        <Thumbnail size="medium" source={getBadgePhotoUrl(associate.alias)} />
        <Column spacing="none">
          <Text transform="capitalize" type="h200">
            {associate.name || ''}
          </Text>
          <Text type="b200" color="secondary">{`ID: ${associate.alias}`}</Text>
        </Column>
      </Row>
      <ProcessPathListView processPathList={associate.trainedPaths} title="Trained" />
      <ProcessPathListView processPathList={associate.disallowedPaths} title="Disallowed" />
      <AssignDestinationPicker
        associate={associate}
        from={{ boardEntry: currentBoardEntryId }}
        onAssigned={onAssigned}
      />
    </Column>
  );
};

export default AssignAssociatePanel;
